import React, { useState, useEffect } from 'react';
import apiService from '../services/api';

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    filter_post: '',
    filter_location: ''
  });
  const [showJobModal, setShowJobModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationForm, setApplicationForm] = useState({
    name: '',
    email: '',
    mobile: '',
    location: '',
    experience: '',
    company: '',
    resume: null,
    cover_letter: ''
  });

  useEffect(() => {
    loadJobs();
  }, [filters]);

  const loadJobs = async () => {
    setLoading(true);
    try {
      const data = await apiService.getJobs(filters.filter_post, filters.filter_location);
      if (data.success) {
        setJobs(data.jobs || []);
      }
    } catch (error) {
      console.error('Error loading jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const openJobApplication = (job) => {
    setSelectedJob(job);
    setShowJobModal(true);
  };

  const handleApplicationSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(applicationForm).forEach(key => {
      if (key === 'resume' && applicationForm[key]) {
        formData.append(key, applicationForm[key]);
      } else {
        formData.append(key, applicationForm[key]);
      }
    });
    if (selectedJob) {
      formData.append('job_id', selectedJob.id);
      formData.append('position', selectedJob.job_title);
    }

    try {
      const result = await apiService.submitJobApplication(formData);
      if (result.success) {
        alert('Thank you for your application! Our HR team will review it and get back to you soon.');
        setShowJobModal(false);
        setApplicationForm({
          name: '',
          email: '',
          mobile: '',
          location: '',
          experience: '',
          company: '',
          resume: null,
          cover_letter: ''
        });
      } else {
        alert(result.message || 'Error submitting application. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>Career Opportunities</h1>
          <p>Join our team and grow with BSB Fortrade</p>
        </div>
      </section>

      <section className="job-filters section-padding bg-light">
        <div className="container">
          <div className="filters-container">
            <div className="filter-header">
              <h3>
                <i className="fas fa-filter"></i>
                Filter Jobs
              </h3>
            </div>
            <form className="filters-form">
              <div className="filter-row">
                <div className="filter-group">
                  <label htmlFor="filter_post">
                    <i className="fas fa-briefcase"></i>
                    Job Post
                  </label>
                  <select name="filter_post" id="filter_post" value={filters.filter_post} onChange={handleFilterChange}>
                    <option value="">All Posts</option>
                  </select>
                </div>
        
                <div className="filter-group">
                  <label htmlFor="filter_location">
                    <i className="fas fa-map-marker-alt"></i>
                    Location
                  </label>
                  <select name="filter_location" id="filter_location" value={filters.filter_location} onChange={handleFilterChange}>
                    <option value="">All Locations</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="job-openings section-padding">
        <div className="container">
          <div className="section-header">
            <h2>Current Job Openings</h2>
            <p>{jobs.length} position{jobs.length !== 1 ? 's' : ''} available</p>
          </div>
          
          <div className="jobs-grid">
            {loading ? (
              <div className="no-vacancy-card">
                <i className="fas fa-spinner fa-spin"></i>
                <p>Loading jobs...</p>
              </div>
            ) : jobs.length > 0 ? (
              jobs.map((job) => (
                <div key={job.id} className="job-card">
                  <div className="job-header">
                    <div className="job-title-row">
                      <h3>{job.job_title}</h3>
                      <span className="job-code">BSB-{String(job.id).padStart(4, '0')}</span>
                    </div>
                    {job.department && (
                      <span className="job-department">{job.department}</span>
                    )}
                  </div>
                  
                  <div className="job-details">
                    {job.location && (
                      <div className="job-info-item">
                        <i className="fas fa-map-marker-alt"></i>
                        <span>{job.location}</span>
                      </div>
                    )}
                    {job.experience && (
                      <div className="job-info-item">
                        <i className="fas fa-briefcase"></i>
                        <span>{job.experience}</span>
                      </div>
                    )}
                    {job.job_type && (
                      <div className="job-info-item">
                        <i className="fas fa-clock"></i>
                        <span>{job.job_type}</span>
                      </div>
                    )}
                  </div>
                  
                  {job.description && (
                    <div className="job-description">
                      <p>{job.description.substring(0, 150)}{job.description.length > 150 ? '...' : ''}</p>
                    </div>
                  )}
                  
                  <div className="job-actions">
                    <button className="btn btn-apply" onClick={() => openJobApplication(job)}>
                      <i className="fas fa-check"></i>
                      Apply
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-vacancy-card">
                <div className="no-vacancy-icon">
                  <i className="fas fa-info-circle"></i>
                </div>
                <h3>No Jobs Found</h3>
                <p className="no-vacancy-message">
                  Thank you for your interest in joining <strong>BSB Fortrade</strong>. At this time, we do not have any open positions available.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {showJobModal && (
        <div id="job-modal" className="modal" style={{ display: 'block' }}>
          <div className="modal-content">
            <span className="close-modal" onClick={() => setShowJobModal(false)}>&times;</span>
            <h2>Job Application - {selectedJob?.job_title}</h2>
            <form onSubmit={handleApplicationSubmit}>
              <input type="hidden" name="position" value={selectedJob?.job_title || ''} />
              <input type="hidden" name="job_id" value={selectedJob?.id || ''} />
              
              <div className="form-group">
                <label>Full Name *</label>
                <input 
                  type="text" 
                  name="name" 
                  required
                  value={applicationForm.name}
                  onChange={(e) => setApplicationForm({...applicationForm, name: e.target.value})}
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Email *</label>
                  <input 
                    type="email" 
                    name="email" 
                    required
                    value={applicationForm.email}
                    onChange={(e) => setApplicationForm({...applicationForm, email: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label>Mobile *</label>
                  <input 
                    type="tel" 
                    name="mobile" 
                    maxLength="10" 
                    required
                    value={applicationForm.mobile}
                    onChange={(e) => setApplicationForm({...applicationForm, mobile: e.target.value})}
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Current Location *</label>
                  <input 
                    type="text" 
                    name="location" 
                    required
                    value={applicationForm.location}
                    onChange={(e) => setApplicationForm({...applicationForm, location: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <label>Total Experience (Years)</label>
                  <input 
                    type="number" 
                    name="experience" 
                    min="0" 
                    step="0.5" 
                    placeholder="0"
                    value={applicationForm.experience}
                    onChange={(e) => setApplicationForm({...applicationForm, experience: e.target.value})}
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label>Current/Last Company</label>
                <input 
                  type="text" 
                  name="company" 
                  placeholder="Optional"
                  value={applicationForm.company}
                  onChange={(e) => setApplicationForm({...applicationForm, company: e.target.value})}
                />
              </div>
              
              <div className="form-group">
                <label>Upload Resume * (PDF/DOC, Max 5MB)</label>
                <input 
                  type="file" 
                  name="resume" 
                  accept=".pdf,.doc,.docx" 
                  required
                  onChange={(e) => setApplicationForm({...applicationForm, resume: e.target.files[0]})}
                />
              </div>
              
              <div className="form-group">
                <label>Cover Letter</label>
                <textarea 
                  name="cover_letter" 
                  rows="4" 
                  placeholder="Tell us why you're a great fit for this role..."
                  value={applicationForm.cover_letter}
                  onChange={(e) => setApplicationForm({...applicationForm, cover_letter: e.target.value})}
                ></textarea>
              </div>
              
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-paper-plane"></i>
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Career;

